export enum MasterServiceProviderActionDispatchTypes {
  MASTER_SERVICE_PROVIDER_INVOKE = "MASTER_SERVICE_PROVIDER_INVOKE",
  MASTER_SERVICE_PROVIDER_SUCCESS = "MASTER_SERVICE_PROVIDER_SUCCESS",
  MASTER_SERVICE_PROVIDER_ERROR = "MASTER_SERVICE_PROVIDER_ERROR",
  MASTER_SERVICE_PROVIDER_RESET = "MASTER_SERVICE_PROVIDER_RESET",
}

export enum MasterServiceProviderDefaultActionDispatchTypes {
  MASTER_SERVICE_PROVIDER_DEFAULT_INVOKE = "MASTER_SERVICE_PROVIDER_DEFAULT_INVOKE",
  MASTER_SERVICE_PROVIDER_DEFAULT_SUCCESS = "MASTER_SERVICE_PROVIDER_DEFAULT_SUCCESS",
  MASTER_SERVICE_PROVIDER_DEFAULT_ERROR = "MASTER_SERVICE_PROVIDER_DEFAULT_ERROR",
  MASTER_SERVICE_PROVIDER_DEFAULT_RESET = "MASTER_SERVICE_PROVIDER_DEFAULT_RESET",
}

export const SORT_TYPE = [
  { key: "providerName", type: "providerName" },
  { key: "providerNpi", type: "providerNpi" },
  { key: "providerState", type: "providerState" },
];